import Form from '@rjsf/material-ui';
import React, { Component } from 'react';
import { INTERVAL, TYPE_SUCCESS } from 'assets/constants/Constants';
import Spinner from 'components/Spinner';
import validator from '@rjsf/validator-ajv6';
import ShowToast from 'components/ShowToast';
import moment from 'moment';
import { getStepList, getFieldData, createStep, updateStep } from 'lib/axiosUtils'; // keeping getFieldData if you still need it elsewhere
import { FILE_ICON } from 'assets/constants/Icons';

export class CreateStepPage extends Component {
    constructor(props) {
        super(props);

        const editData = props.location.state ? props.location.state : null;

        // Try to derive duration from editData if present
        let derivedDuration = null;
        try {
            const prop =
                editData &&
                editData.formSchema &&
                editData.formSchema.properties &&
                editData.formSchema.properties.durationDays;
            if (prop && typeof prop.default !== 'undefined') {
                derivedDuration = Number(prop.default);
            }
        } catch (e) {
            // ignore
        }

        this.state = {
            isLoading: true,
            // edit context
            editData: editData,
            stepId: editData === null ? null : editData.stepId,
            stepTitle: editData === null ? '' : editData.stepTitle || '',
            shortDescription: editData === null ? '' : editData.shortDescription || '',
            durationDays:
                editData && typeof editData.durationDays !== 'undefined'
                    ? Number(editData.durationDays)
                    : derivedDuration !== null
                    ? derivedDuration
                    : '',

            // preview/save helpers
            flag: false, // show preview modal
            saveFlag: false, // whether we are saving (vs just previewing)
            formSchema: {},
            uiSchema: {},

            // errors
            error: {},
        };
    }

    async componentDidMount() {
        console.log('[CreateStepPage] componentDidMount');
        try {
            // If you don’t need fields anymore, you can skip this; left here in case the API is expected.
            const stepField = await getFieldData({}, {});
            console.log('[CreateStepPage] getFieldData success', stepField?.data);
        } catch (e) {
            console.log('[CreateStepPage] getFieldData failed (ignored for this page)', e);
        } finally {
            this.setState({ isLoading: false }, () => {
                console.log('[CreateStepPage] isLoading set to false');
            });
        }
    }

    setStepTitle = (value) => {
        console.log('[CreateStepPage] setStepTitle:', value);
        this.setState({ stepTitle: value });
    };

    setShortDescription = (value) => {
        console.log('[CreateStepPage] setShortDescription:', value);
        this.setState({ shortDescription: value });
    };

    setDurationDays = (value) => {
        const parsed = value === '' ? '' : Number(value);
        console.log('[CreateStepPage] setDurationDays:', parsed);
        this.setState({ durationDays: parsed });
    };

    validate = async () => {
        let isValid = true;
        let error = {};

        if (!this.state.stepTitle || this.state.stepTitle.trim() === '') {
            isValid = false;
            error.stepTitle = 'Please enter step title';
        }else {
            try {
                // 2. Fetch existing step titles from the backend
                const formsData = await getStepList({}, {});
                const formList = formsData.data.result;
                console.log("formList",formList);
                const enteredStepTitle = this.state.stepTitle.trim().toLowerCase();
                console.log("enteredStepTitle",enteredStepTitle);
                // 3. Check if the entered title already exists
                const exists = formList.some(item => item.step_title.trim().toLowerCase() === enteredStepTitle);
    
                if (exists) {
                    console.log("existed alraedy present");
                    isValid = false;
                    error.stepTitle = 'Step title already exists';
                    window.alert('Step title already exists!');
                }else{
                    console.log("not existed not present");
                }
            } catch (err) {
                console.error('Error checking step title:', err);
            }
        }

        // if (!this.state.shortDescription || this.state.shortDescription.trim() === '') {
        //     isValid = false;
        //     error.shortDescription = 'Please enter step description';
        // }

        if (
            this.state.durationDays === '' ||
            this.state.durationDays === null ||
            Number.isNaN(Number(this.state.durationDays))
        ) {
            isValid = false;
            error.durationDays = 'Please enter duration in days';
        } else if (Number(this.state.durationDays) <= 0) {
            isValid = false;
            error.durationDays = 'Duration must be greater than 0';
        }
        
        this.setState({ error });
        console.log('[CreateStepPage] validate:', { isValid, error });
        return isValid;
    };

    addFormHandler = async (stepId, stepTitle, formSchema, uiSchema) => {
        if (window.confirm('Are you sure you want to save step?')) {
            const requestParameter = {
                stepId: stepId,
                stepTitle: stepTitle,
                shortDescription: this.state.shortDescription,
                durationDays: Number(this.state.durationDays), // include as a top-level field
                formSchema: formSchema,
                uiSchema: uiSchema,
            };

            console.log('[CreateStepPage] addFormHandler request:', requestParameter);

            try {
                if (requestParameter.stepId === null) {
                    const res = await createStep({}, requestParameter);
                    console.log('[CreateStepPage] createStep success:', res);
                    ShowToast(
                        'Step created successfully',
                        TYPE_SUCCESS,
                        INTERVAL,
                        this.props,
                        '/step-list-page'
                    );
                } else {
                    const res = await updateStep({}, requestParameter);
                    console.log('[CreateStepPage] updateStep success:', res);
                    ShowToast(
                        'Step updated successfully',
                        TYPE_SUCCESS,
                        INTERVAL,
                        this.props,
                        '/step-list-page'
                    );
                }
            } catch (error) {
                console.log(
                    `Error occurred while ${
                        requestParameter.stepId ? 'Updating' : 'Creating'
                    } the Step`,
                    error
                );
            }
        }
    };

    saveData = async () => {
        const isValid = await this.validate();
        if (isValid) {
            this.setState({ saveFlag: true }, () => {
                console.log('[CreateStepPage] saveData -> previewData (saveFlag=true)');
                this.previewData();
            });
        }
    };

    previewData = async () => {
        console.log('[CreateStepPage] previewData start');
        if (!this.validate()) {
            console.log('[CreateStepPage] previewData aborted: validation failed');
            return;
        }

        // Build a minimal JSON Schema with only the required three fields
        const createSchema = {
            title: this.state.stepTitle,
            description: this.state.shortDescription,
            type: 'object',
            required: ['durationDays'],
            properties: {
                durationDays: {
                    title: 'Duration (in days)',
                    type: 'number',
                    minimum: 1,
                    default:
                        this.state.durationDays === '' || this.state.durationDays === null
                            ? undefined
                            : Number(this.state.durationDays),
                },
            },
        };

        const uiSchema = {
            'ui:submitButtonOptions': {
                submitText: 'Submit',
                norender: false,
                props: {
                    disabled: false,
                    className: 'btn btn-info',
                },
            },
            durationDays: {
                'ui:widget': 'updown',
                'ui:help': 'Enter the number of days (e.g., 3)',
            },
        };

        console.log('[CreateStepPage] previewData schema:', createSchema);
        console.log('[CreateStepPage] previewData uiSchema:', uiSchema);

        if (this.state.saveFlag) {
            await this.addFormHandler(
                this.state.stepId,
                createSchema.title,
                createSchema,
                uiSchema
            );
            return;
        }

        // Preview only
        this.setState(
            {
                formSchema: { schema: createSchema },
                uiSchema: uiSchema,
                flag: true,
            },
            () => console.log('[CreateStepPage] previewData setState done (flag=true)')
        );
    };

    cancelHandler = () => {
        console.log('[CreateStepPage] cancelHandler -> /step-list-page');
        this.props.history.push('/step-list-page');
    };

    render() {
        if (this.state.isLoading) {
            return <Spinner />;
        } else {
            return (
                <div className="main-content">
                    <div className="pagetitle row" style={{ color: 'black', paddingTop: 15, marginTop: '-25px' }}>
                        <div className="col-md-10 sm_device">
                            <i className={`${FILE_ICON}`}></i> Step Creation
                        </div>
                        <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
                            <i className={``}></i> {moment().format('DD MMM YYYY')}
                        </div>
                    </div>

                    <div
                        style={{
                            borderBottom: '1px solid lightgray',
                            marginBottom: 15,
                            marginTop: 15,
                        }}
                    />

                    <div className="list-wrapper">
                        <div
                            className="mt-4 border list-table-div"
                            style={{ marginBottom: 50, paddingTop: 20 }}
                        >
                            <div className="App">
                                <div className="row">
                                    <div className="col-md-8">
                                        <h4 className="pagetitle">
                                            <b>
                                                {this.state.editData === null
                                                    ? 'Create New Step'
                                                    : 'Edit Step'}
                                            </b>
                                        </h4>
                                        <br />

                                        {/* Step Title */}
                                        <label>Step Title : </label>
                                        <br />
                                        <input
                                            type="text"
                                            className="form-control brand-font placeholderColor"
                                            style={{ padding: "2rem", fontSize: "1.3rem", width: "50rem"}}
                                            value={this.state.stepTitle}
                                            onChange={(e) => this.setStepTitle(e.target.value)}
                                            placeholder="Enter step title"
                                        />
                                        <div className="text-danger error-msg">
                                            {this.state.error.stepTitle}
                                        </div>

                                        {/* Step Description */}
                                        <label className="mt-3">Step Description :</label>
                                        <br />
                                        <textarea
                                            rows={4}
                                            cols={80}
                                            style={{
                                                maxWidth: '100%',
                                                border: '1px solid lightgrey',
                                                padding: '2px',
                                            }}
                                            value={this.state.shortDescription}
                                            onChange={(e) =>
                                                this.setShortDescription(e.target.value)
                                            }
                                            placeholder="Enter step description"
                                        />
                                        {/* <div className="text-danger error-msg">
                                            {this.state.error.shortDescription}
                                        </div> */}

                                        {/* Duration (in days) */}
                                        <div className="row mt-3">
                                            <div className="col-md-5">
                                                <label>
                                                    Duration (in days){' '}
                                                    <span className="text-danger">*</span> :
                                                </label>
                                                <br />
                                                <input
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    className="form-control brand-font placeholderColor"
                                                    style={{ padding: "2rem", fontSize: "1.3rem" }}
                                                    value={this.state.durationDays}
                                                    onChange={(e) =>
                                                        this.setDurationDays(e.target.value)
                                                    }
                                                    placeholder="Enter number of days"
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.durationDays}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="row mt-4 mb-5">
                                    <div className="col-md-8">
                                        {/* <button className="brand-button" onClick={this.previewData}>
                                            Preview
                                        </button> */}
                                        <button
                                            className="brand-button ml-5"
                                            onClick={this.saveData}
                                        >
                                            Save
                                        </button>
                                        <button
                                            className="cancel_button ml-5"
                                            onClick={this.cancelHandler}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                                {/* Preview Modal */}
                                <div className="row" style={{ paddingBottom: 20 }}>
                                    {this.state.flag && (
                                        <div className="custom_modal">
                                            <div className="modal_body">
                                                <button
                                                    type="button"
                                                    style={{ fontSize: 20 }}
                                                    className="close text-right"
                                                    onClick={() => {
                                                        console.log(
                                                            '[CreateStepPage] close preview modal'
                                                        );
                                                        this.setState({ flag: false });
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                                <Form
                                                    schema={this.state.formSchema.schema}
                                                    uiSchema={this.state.uiSchema}
                                                    validator={validator}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default CreateStepPage;
